import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import type { FC } from 'react';

import type { ProjectFormikType } from '@core/formik/project';
import Enums from '@core/types/api/Enums';
import { hasValue } from '@core/utils/equality';
import { PlantAccordionFormik } from '@web/components/PlantAccordionFormik/PlantAccordionFormik';
import {
  ProductSection,
  type ProductSectionProps,
} from '@web/components/ProductSection/ProductSection';
import { SquaredBadge } from '@web/components/SquaredBadge/SquaredBadge';

interface LocationFormProps {
  index: number;
  arrayHelpers: {
    remove: (index: number) => void;
  };
  curProductsRef: ProductSectionProps['curProductsRef'];
}

const LocationForm: FC<LocationFormProps> = ({ index, arrayHelpers, curProductsRef }) => {
  const formikBag = useFormikContext<ProjectFormikType>();

  const plants = formikBag.values.productsByPlants;
  const plant = plants[index];
  const hasSelectedPlant = hasValue(plant.plant.id);

  // Get all selected plant IDs except the current one
  const otherSelectedPlantIds = plants
    .filter((_, idx) => idx !== index)
    .map((loc) => loc.plant?.id)
    .filter((id) => hasValue(id)) as string[];

  return (
    <PlantAccordionFormik
      projectAddress={formikBag.values.address}
      formikName={`productsByPlants.${index}.plant`}
      index={index}
      otherSelectedPlantIds={otherSelectedPlantIds}
      arrayHelpers={arrayHelpers}
      onMatchChange={(value) => {
        formikBag.setFieldValue(`productsByPlants.${index}.autoSelected`, false);
        if (value !== null && value !== plant.plant.id) {
          formikBag.setFieldValue(`productsByPlants.${index}.products`, []);
        }
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {hasSelectedPlant && (
          <>
            {plant.products.length > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant='body1' sx={{ fontWeight: 500 }}>
                  Selected Products:
                </Typography>
                <SquaredBadge badgeContent={plant.products.length} />
              </Box>
            )}

            <ProductSection
              sectionType={Enums.QuoteProductKind.Primary}
              plant={plant.plant}
              curProductsRef={curProductsRef}
              project={null}
              projectProductsByProductID={{}}
              plantIndex={index}
            />
          </>
        )}
      </Box>
    </PlantAccordionFormik>
  );
};

export default LocationForm;
